export default __webpack_public_path__ + "static/media/evenShotBg.d696a7a2.png";